// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"218":"d78355a5","594":"c99d1b89"}[chunkId] + ".css";
};